var _style, _ellipse, _path, _path2, _path3, _path4, _path5, _rect, _circle, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _polygon, _polygon2, _polygon3, _polygon4, _rect2, _polygon5, _polygon6, _polygon7, _polygon8, _rect3, _path29, _path30, _rect4, _path31, _circle2, _circle3, _rect5, _rect6, _rect7, _path32, _polygon9, _rect8, _polygon10, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _line, _line2, _line3, _line4, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _polygon11, _polygon12, _polygon13, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _ellipse2, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgValue(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "a6f4e524-a1b8-434a-a0ca-43acb27f4769",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 1110.5 857.7",
    style: {
      enableBackground: "new 0 0 1110.5 857.7"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{opacity:0.1;fill:#919191;enable-background:new    ;}\n\t.st1{fill:rgb(0, 83, 74);enable-background:new    ;}\n\t.st2{fill:#2A2A2B;}\n\t.st3{opacity:0.1;fill:#B2B2B2;enable-background:new    ;}\n\t.st4{fill:#FFFFFF;}\n\t.st5{fill:#FFFFFF;stroke:#FFFFFF;stroke-miterlimit:10;}\n\t.st6{fill:#2F302F;enable-background:new    ;}\n\t.st7{fill:#504F60;}\n\t.st8{opacity:0.1;enable-background:new    ;}\n\t.st9{opacity:0.1;fill:#F7F7F7;enable-background:new    ;}\n\t.st10{fill:#FFFFFF;stroke:#33313F;stroke-width:3;stroke-miterlimit:10;}\n\t.st11{fill:none;stroke:#33313F;stroke-width:2;stroke-linecap:round;stroke-miterlimit:10;}\n\t.st12{fill:#FFFFFF;stroke:#33313F;stroke-width:2;stroke-linecap:round;stroke-miterlimit:10;}\n\t.st13{fill:none;stroke:#33313F;stroke-width:3;stroke-miterlimit:10;}\n\t.st14{fill:#FFFFFF;stroke:#33313F;stroke-width:3;stroke-linecap:round;stroke-miterlimit:10;}\n\t.st15{fill:#33313F;}\n\t.st16{fill:#65617D;}\n\t.st17{fill:url(#SVGID_1_);}\n\t.st18{fill:#DB8B8B;}\n\t.st19{fill:#2E3037;}\n\t.st20{fill:#35323E;}\n")), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    className: "st0",
    cx: 346.7,
    cy: 821.7,
    rx: 237.5,
    ry: 36
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M342.9,37.8c37.7-33.2,96.8-40,150.6-37.3c169.1,8.3,321.7,89,453.7,180.3c47.8,33.1,94.9,68.6,125.9,114.2 c63.2,92.6,44.4,220.9-43.4,297.2c-29.9,26-66.1,45.9-103.3,63.5C860.4,687.1,789,712.2,714,719.4c-53.5,5.1-107.7,1-160.9-6.2 c-148.6-19.9-294.5-64-416.8-139.4C82.6,540.8,32.1,499.7,10,446.2S2,324.9,56.8,293.3c22.6-13.1,49.7-19,76.2-24.6 c39-8.2,78.7-16.2,113.9-32.8c36.4-17.2,79.4-50.4,72.2-88.3C311.5,106.8,305.2,71,342.9,37.8z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M920.8,88.5c6.8,44.6-12,84.4-12,84.4s-29.8-32.4-36.5-77c-3.8-25,0.5-48.5,4.9-64.3c1.6-5.9,7.7-9.3,13.5-7.7 c2.6,0.7,4.9,2.4,6.4,4.7C906,42.3,917,63.5,920.8,88.5z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M1046.5,159.5c6.7,0,13.4,0.8,19.8,2.5c10.9,2.8,11.1,18.2,0.2,21.3c-6.4,1.8-13.1,2.8-19.8,2.9 c-24.5,0.3-44.6-12.9-44.6-12.9S1022,159.8,1046.5,159.5z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M977.5,91.7c-22.8,25.1-27.7,57.9-27.7,57.9s32.2-7.9,55-33c10.6-11.6,17.3-24.9,21.5-35.8 c2.2-5.7-0.7-12-6.4-14.2c-2.9-1.1-6-0.9-8.8,0.4C1000.7,72.2,988.1,80.1,977.5,91.7z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M531.3,87h474.4c10.9,0,19.8,8.9,19.8,19.8v579.4c0,10.9-8.9,19.8-19.8,19.8H531.3c-10.9,0-19.8-8.9-19.8-19.8 V106.8C511.5,95.9,520.3,87,531.3,87z"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 555.8,
    y: 149.4,
    className: "st3",
    width: 425.3,
    height: 494.1
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "st4",
    cx: 768.5,
    cy: 676.1,
    r: 18.1
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M768.5,131.8c-4.7,0-8.5-3.8-8.5-8.5c0-4.7,3.8-8.6,8.5-8.6c4.7,0,8.5,3.8,8.5,8.5c0,0,0,0,0,0 C777,127.9,773.2,131.7,768.5,131.8z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M768.5,115.2c4.4,0,8,3.6,8,8c0,4.4-3.6,8.1-8,8.1c-4.4,0-8-3.6-8-8c0,0,0,0,0,0 C760.4,118.8,764,115.2,768.5,115.2 M768.5,114.2c-5,0-9.1,4-9.1,9c0,5,4,9.1,9,9.1c5,0,9.1-4,9.1-9c0,0,0,0,0,0 C777.5,118.2,773.5,114.2,768.5,114.2C768.5,114.2,768.5,114.2,768.5,114.2z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M579.9,302.5h79.6c2.4,0,4.3,1.9,4.3,4.3v111.3c0,2.4-1.9,4.3-4.3,4.3h-79.6c-2.4,0-4.3-1.9-4.3-4.3V306.8 C575.6,304.4,577.5,302.5,579.9,302.5z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M591,332.7h57.4c3.9,0,7.1,3.2,7.1,7.1v23.8c0,3.9-3.2,7.1-7.1,7.1H591c-3.9,0-7.1-3.2-7.1-7.1v-23.8 C583.8,335.9,587,332.7,591,332.7z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M600.5,386.3h38.4c0.9,0,1.7,0.8,1.7,1.7v2.5c0,0.9-0.8,1.7-1.7,1.7h-38.4c-0.9,0-1.7-0.8-1.7-1.7V388 C598.8,387.1,599.5,386.3,600.5,386.3z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M729,302.5h79.6c2.4,0,4.3,1.9,4.3,4.3v111.3c0,2.4-1.9,4.3-4.3,4.3H729c-2.4,0-4.3-1.9-4.3-4.3V306.8 C724.7,304.4,726.6,302.5,729,302.5z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M749.4,321.2h39.3c0.8,0,1.5,0.7,1.5,1.5v19.5c0,0.8-0.7,1.5-1.5,1.5h-39.3c-0.8,0-1.5-0.7-1.5-1.5v-19.5 C747.9,321.9,748.5,321.2,749.4,321.2z"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M743.4,364.7H794c0.9,0,1.7,0.8,1.7,1.7v2.5c0,0.9-0.8,1.7-1.7,1.7h-50.6c-0.9,0-1.7-0.8-1.7-1.7v-2.5 C741.7,365.5,742.5,364.7,743.4,364.7z"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M743.4,375.7H794c0.9,0,1.7,0.8,1.7,1.7v2.5c0,0.9-0.8,1.7-1.7,1.7h-50.6c-0.9,0-1.7-0.8-1.7-1.7v-2.5 C741.7,376.5,742.5,375.7,743.4,375.7z"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M877.5,217.3h79.6c2.4,0,4.3,1.9,4.3,4.3v111.3c0,2.4-1.9,4.3-4.3,4.3h-79.6c-2.4,0-4.3-1.9-4.3-4.3V221.6 C873.2,219.2,875.1,217.3,877.5,217.3z"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M890,235.9h54.5c0.8,0,1.5,0.7,1.5,1.5v23.9c0,0.8-0.7,1.5-1.5,1.5H890c-0.8,0-1.5-0.7-1.5-1.5v-23.9 C888.5,236.6,889.2,235.9,890,235.9z"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M890,274.9h54.5c0.8,0,1.5,0.7,1.5,1.5v23.9c0,0.8-0.7,1.5-1.5,1.5H890c-0.8,0-1.5-0.7-1.5-1.5v-23.9 C888.5,275.5,889.2,274.9,890,274.9z"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M887.8,323.3H899c2.1,0,3.8,1.7,3.8,3.8v0.6c0,2.1-1.7,3.8-3.8,3.8h-11.2c-2.1,0-3.8-1.7-3.8-3.8v-0.6 C884,325,885.7,323.3,887.8,323.3z"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M911.7,323.3h11.2c2.1,0,3.8,1.7,3.8,3.8v0.6c0,2.1-1.7,3.8-3.8,3.8h-11.2c-2.1,0-3.8-1.7-3.8-3.8v-0.6 C907.8,325,909.6,323.3,911.7,323.3z"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M935.6,323.3h11.2c2.1,0,3.8,1.7,3.8,3.8v0.6c0,2.1-1.7,3.8-3.8,3.8h-11.2c-2.1,0-3.8-1.7-3.8-3.8v-0.6 C931.7,325,933.4,323.3,935.6,323.3z"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M877.2,387.7h79.6c2.4,0,4.3,1.9,4.3,4.3v111.3c0,2.4-1.9,4.3-4.3,4.3h-79.6c-2.4,0-4.3-1.9-4.3-4.3V392 C872.9,389.6,874.9,387.7,877.2,387.7z"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M881.2,401.7h23.4c0.8,0,1.5,0.7,1.5,1.5v23.9c0,0.8-0.7,1.5-1.5,1.5h-23.4c-0.8,0-1.5-0.7-1.5-1.5v-23.9 C879.8,402.4,880.4,401.7,881.2,401.7z"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M891.8,444.8h50.6c0.9,0,1.7,0.8,1.7,1.7v2.5c0,0.9-0.8,1.7-1.7,1.7h-50.6c-0.9,0-1.7-0.8-1.7-1.7v-2.5 C890.1,445.6,890.8,444.8,891.8,444.8z"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M891.8,456.8h50.6c0.9,0,1.7,0.8,1.7,1.7v2.5c0,0.9-0.8,1.7-1.7,1.7h-50.6c-0.9,0-1.7-0.8-1.7-1.7v-2.5 C890.1,457.5,890.8,456.8,891.8,456.8z"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M891.8,468.7h50.6c0.9,0,1.7,0.8,1.7,1.7v2.5c0,0.9-0.8,1.7-1.7,1.7h-50.6c-0.9,0-1.7-0.8-1.7-1.7v-2.5 C890.1,469.5,890.8,468.7,891.8,468.7z"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M714.5,359.6l-1.3,0.6l-10.9,5.3l-1,0.5c-0.3,0.1-0.6,0-0.7-0.3c0,0,0,0,0,0c0-0.1,0-0.1,0-0.2v-3.1 c0-0.3-0.2-0.5-0.5-0.5l0,0h-26.6c-0.3,0-0.5-0.2-0.5-0.5v-4.4c0-0.3,0.2-0.5,0.5-0.5H700c0.3,0,0.5-0.2,0.5-0.5v-3.2 c0-0.1,0-0.1,0-0.2c0.1-0.3,0.4-0.4,0.7-0.3c0,0,0,0,0,0l1,0.5l10.9,5.3l1.3,0.7c0.3,0.1,0.4,0.4,0.3,0.7 C714.7,359.5,714.6,359.6,714.5,359.6z"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M862.5,332.6l-0.9,1.2l-7.2,9.8l-0.6,0.9c-0.2,0.2-0.5,0.3-0.8,0.1c0,0,0,0,0,0c-0.1,0-0.1-0.1-0.1-0.2 l-1.5-2.7c-0.1-0.3-0.5-0.4-0.7-0.2l-23.5,12.5c-0.3,0.1-0.6,0-0.7-0.2c0,0,0,0,0,0l-2.1-3.9c-0.1-0.3,0-0.6,0.2-0.7c0,0,0,0,0,0 l23.5-12.5c0.3-0.1,0.4-0.5,0.2-0.7c0,0,0,0,0,0l-1.5-2.8c0-0.1-0.1-0.1-0.1-0.2c0-0.3,0.2-0.5,0.4-0.6c0,0,0,0,0.1,0h1.1l12.1-0.4 l1.5,0c0.3,0,0.5,0.2,0.5,0.5C862.6,332.5,862.6,332.6,862.5,332.6z"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M862.5,383.9H861h-12.1h-1.1c-0.3,0-0.5-0.2-0.5-0.5c0,0,0,0,0,0c0-0.1,0-0.1,0-0.2l1.3-2.8 c0.1-0.3,0-0.6-0.2-0.7c0,0,0,0,0,0l-24-11.5c-0.3-0.1-0.4-0.5-0.2-0.7l1.9-4c0.1-0.3,0.4-0.4,0.7-0.3c0,0,0,0,0,0l24,11.5 c0.3,0.1,0.6,0,0.7-0.2l1.4-2.9c0.1-0.3,0.4-0.4,0.7-0.3c0.1,0,0.1,0.1,0.2,0.2l0.7,0.8l7.5,9.5l0.9,1.2c0.2,0.2,0.2,0.6,0,0.7 C862.7,383.9,862.6,383.9,862.5,383.9z"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "st7",
    points: "424.2,606.7 424.1,609.6 419,789.7 410.4,789.7 414.6,609.6 414.7,606.2 "
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    className: "st2",
    points: "424.2,606.7 424.1,609.6 419,789.7 410.4,789.7 414.6,609.6 414.7,606.2 "
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    className: "st2",
    points: "473.8,759.2 467.4,759.2 372,759 366.9,759 369.6,750.6 473.2,750.6 "
  })), _polygon4 || (_polygon4 = /*#__PURE__*/React.createElement("polygon", {
    className: "st8",
    points: "424.2,606.7 424.1,609.6 414.6,609.6 414.7,606.2 "
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 411.9,
    y: 602.2,
    className: "st2",
    width: 15.9,
    height: 6
  })), _polygon5 || (_polygon5 = /*#__PURE__*/React.createElement("polygon", {
    className: "st8",
    points: "372.8,750.6 372,759 366.9,759 369.6,750.6 "
  })), _polygon6 || (_polygon6 = /*#__PURE__*/React.createElement("polygon", {
    className: "st2",
    points: "386.5,602.1 386.2,604.7 365.1,813.6 355.4,813.1 377.7,604.7 377.9,602.4 "
  })), _polygon7 || (_polygon7 = /*#__PURE__*/React.createElement("polygon", {
    className: "st8",
    points: "473.8,759.2 467.4,759.2 466.5,750.6 473.2,750.6 "
  })), _polygon8 || (_polygon8 = /*#__PURE__*/React.createElement("polygon", {
    className: "st2",
    points: "484,813.1 474.3,813.6 453.1,604.7 452.9,602.1 461.4,602.4 461.7,604.7 "
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 311.4,
    y: 396.2,
    className: "st4",
    width: 213.9,
    height: 205.1
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M268.6,396.2h299.7c2.3,0,4.1,1.8,4.1,4.1v196.9c0,2.3-1.8,4.1-4.1,4.1H268.6c-2.3,0-4.1-1.8-4.1-4.1V400.4 C264.5,398.1,266.3,396.2,268.6,396.2z"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M422.5,327.6v49.5h-8.3v-49.5c0-2.3,1.9-4.2,4.2-4.2C420.6,323.5,422.5,325.3,422.5,327.6 C422.5,327.6,422.5,327.6,422.5,327.6z"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 414.2,
    y: 372.7,
    className: "st8",
    width: 8.4,
    height: 4.5
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M425.8,376v16.4h-14.9V376c0-1.1,0.9-2,2-2h10.8C424.8,374,425.7,374.9,425.8,376 C425.8,376,425.8,376,425.8,376z"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    className: "st8",
    cx: 418.3,
    cy: 384.4,
    r: 3.2
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    className: "st9",
    cx: 418.3,
    cy: 383.7,
    r: 3.2
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 410.9,
    y: 390.4,
    className: "st8",
    width: 14.9,
    height: 2
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 404.8,
    y: 393.1,
    className: "st8",
    width: 27.1,
    height: 4.5
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 404.8,
    y: 391.7,
    className: "st2",
    width: 27.1,
    height: 4.5
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M364.6,596h111.6c3.3,0,6,2.7,6,6l0,0l0,0H358.6l0,0l0,0C358.6,598.7,361.3,596,364.6,596z"
  })), _polygon9 || (_polygon9 = /*#__PURE__*/React.createElement("polygon", {
    className: "st8",
    points: "377.9,602.4 386.5,602.1 386.2,604.7 377.7,604.7 "
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 411.9,
    y: 602.2,
    className: "st8",
    width: 15.9,
    height: 2.5
  })), _polygon10 || (_polygon10 = /*#__PURE__*/React.createElement("polygon", {
    className: "st8",
    points: "461.7,604.7 453.1,604.7 452.9,602.1 461.4,602.4 "
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M364.6,597.4h111.6c3.3,0,6,2.7,6,6l0,0l0,0H358.6l0,0l0,0C358.6,600.1,361.3,597.4,364.6,597.4L364.6,597.4z"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M517.8,420.3c0.8-0.1,1.6,0.4,1.7,1.2c0,0.1,0,0.3,0,0.4c-1.5,14-0.5,28.3,1,42.3c0.7,6.4,1.7,13.1,4.5,17.9 c0.4,0.6,0.3,1.4-0.2,1.9c-0.8,0.6-1.8,0.9-2.8,0.8l-44.6,0.2c-0.8,0-1.5-0.7-1.5-1.5c0-0.1,0-0.2,0-0.4c3.6-15.3,2.8-32,1.4-47.9 c-0.7-7.8-1.1-12,4.7-12.5c6-0.5,12-0.8,18-1.3C501.6,421.4,513.1,421.1,517.8,420.3z"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M483.7,512c-0.8-0.1-1.6,0.4-1.7,1.2c0,0.1,0,0.3,0,0.4c1.5,14,0.5,28.3-1.1,42.3c-0.7,6.4-1.7,13.2-4.5,17.9 c-0.4,0.6-0.3,1.4,0.2,1.8c0.8,0.6,1.8,0.9,2.8,0.8l44.6,0.3c0.8,0,1.5-0.7,1.5-1.5c0-0.1,0-0.2,0-0.3c-3.6-15.3-2.8-32-1.4-47.9 c0.7-7.8,1.1-12-4.7-12.5s-12-0.8-18-1.3C499.9,513.1,488.4,512.8,483.7,512z"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M496.8,537.8c5.2-0.2,10.4-0.2,15.6,0.2c0.7,0.1,1.2,0.6,1.3,1.3l0.5,4.1c0.1,0.2,0,0.4-0.1,0.5 c-0.1,0.1-0.2,0.1-0.4,0.1c-2.2,0.1-4.4-0.2-6.5,0c-1.3,0.1-2.7,0.4-4,0.5c-2.2,0.2-4.4,0.2-6.7,0.1c-3.1,0.1-6.2-0.3-9.3-1.1 c0,0,0.2-3.4,0.2-3.7c0-1.6,0-1.7,1.6-1.8L496.8,537.8z"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M496.8,556.2c5.2,0.2,10.4,0.2,15.6-0.2c0.7-0.1,1.2-0.6,1.3-1.3l0.5-4.1c0.1-0.2,0-0.4-0.1-0.5 c-0.1-0.1-0.2-0.1-0.4-0.1c-2.2-0.1-4.4,0.2-6.5,0c-1.3-0.1-2.7-0.4-4-0.5c-2.2-0.2-4.4-0.2-6.7-0.1c-3.1-0.1-6.2,0.3-9.3,1.1 c0,0,0.2,3.4,0.2,3.7c0,1.6,0,1.7,1.6,1.8L496.8,556.2z"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M496.8,563.4c5.2-0.2,10.4-0.2,15.6,0.2c0.7,0.1,1.2,0.6,1.3,1.3l0.5,4.1c0.1,0.2,0,0.4-0.1,0.5 c-0.1,0.1-0.2,0.1-0.4,0.1c-2.2,0.1-4.4-0.2-6.5,0c-1.3,0.1-2.7,0.4-4,0.5c-2.2,0.2-4.4,0.2-6.7,0.1c-3.1,0.1-6.2-0.3-9.3-1.1 c0,0,0.2-3.4,0.2-3.7c0-1.6,0-1.7,1.6-1.8L496.8,563.4z"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M503.4,477.8c0.5,1.1,0.6,2.3,0.4,3.5c0,0.1,0,0.2-0.1,0.3c-0.1,0.1-0.3,0.2-0.4,0.1l-9.5,0.4 c0,0,0.5-2.8,0.6-3c0.3-1.1,1.2-0.8,2.2-0.9L503.4,477.8z"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M517.7,477.8c0.5,1.1,0.6,2.3,0.4,3.5c0,0.1,0,0.2-0.1,0.3c-0.1,0.1-0.3,0.2-0.4,0.1l-9.5,0.4 c0,0,0.5-2.8,0.6-3c0.3-1.1,1.2-0.8,2.2-0.9L517.7,477.8z"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M512,430.1l1.3,11c0.2,1.6-1,3.1-2.7,3.3c0,0,0,0-0.1,0c-8.1,0.6-16.3,0.6-24.4-0.2c-1.5-0.1-2.6-1.4-2.7-2.9 c-0.2-2-0.4-3.9-0.9-5.8c-0.3-2-0.7-3.9,1.7-4.5s5.6-0.2,8.2-0.2c3.1-0.1,6.2-0.1,9.2-0.3C502.5,430.6,512,430,512,430.1z"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M512,469.8l1.3-11c0.2-1.6-1-3.1-2.7-3.3c0,0,0,0-0.1,0c-8.1-0.6-16.3-0.6-24.4,0.1c-1.5,0.1-2.7,1.4-2.7,2.9 c-0.2,2-0.4,3.9-0.9,5.8c-0.3,2-0.7,3.9,1.7,4.5s5.6,0.2,8.2,0.2c3.1,0.1,6.2,0.1,9.2,0.3C502.5,469.4,512,469.9,512,469.8z"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M499.1,519.4c-0.3,3.7-0.5,7.3-0.6,11c-3.7,0-7.3-0.4-10.9-1.2c-1.1-0.1-1.9-1-1.8-2c0-0.1,0-0.2,0-0.3 c-0.1-2.3-1.3-7.4,1.9-7.7C488.7,519,499.1,519.6,499.1,519.4z"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M322.6,469.4c1.8-0.2,3.3,1.1,3.5,2.8c0,0.2,0,0.4,0,0.6c-1.1,13.3-0.2,26.9,1.3,40.2 c0.7,5.9,1.6,12.1,3.9,16.8c0.7,1.3,0.2,2.9-1.1,3.5c-0.4,0.2-0.8,0.3-1.2,0.3l0,0l-44.3,0.3c-1,0-1.8-0.8-1.8-1.7 c0-0.1,0-0.3,0-0.4c3.5-15.2,2.7-31.8,1.3-47.6c-0.7-7.8-1.1-12,4.7-12.5c6-0.5,12-0.8,18-1.3C308.2,470.3,317.2,470,322.6,469.4z"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M384.2,469.2c-0.9-0.1-1.7,0.5-1.8,1.3c0,0.1,0,0.3,0,0.4c1.4,13.9,0.5,28.2-1.1,42.2 c-0.7,6.4-1.7,13.1-4.5,17.9c-0.4,0.7-0.2,1.6,0.4,2.1c0.8,0.5,1.6,0.7,2.5,0.6l44.5,0.3c0.9,0,1.6-0.7,1.6-1.6c0-0.1,0-0.3-0.1-0.4 c-3.5-15.3-2.8-32-1.4-47.8c0.7-7.8,1.1-12-4.7-12.5c-6-0.5-12-0.8-18-1.3C400.2,470.3,388.9,470,384.2,469.2z"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    className: "st11",
    x1: 296,
    y1: 478.3,
    x2: 318.7,
    y2: 508.5
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    className: "st11",
    x1: 318.7,
    y1: 476,
    x2: 296.8,
    y2: 510
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    className: "st11",
    x1: 397.1,
    y1: 479.7,
    x2: 409.4,
    y2: 496.2
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    className: "st11",
    x1: 409.4,
    y1: 478.5,
    x2: 397.5,
    y2: 497
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M303.5,518.1c5.2-0.2,10.4-0.2,15.6,0.2c0.7,0.1,1.2,0.6,1.3,1.3l0.5,4.1c0,0.2,0,0.4-0.1,0.5 c-0.1,0.1-0.2,0.1-0.4,0.1c-2.2,0.1-4.4-0.2-6.5,0c-1.4,0.1-2.7,0.4-4,0.5c-2.2,0.2-4.4,0.2-6.7,0.1c-3.1,0.1-6.2-0.3-9.3-1.1 c-0.1,0,0.2-3.4,0.2-3.7c0-1.6-0.1-1.7,1.6-1.8L303.5,518.1z"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M398.6,503c5.2-0.2,10.4-0.2,15.6,0.2c0.7,0.1,1.2,0.6,1.3,1.3l0.5,4.1c0,0.2,0,0.4-0.1,0.5 c-0.1,0.1-0.2,0.1-0.4,0.1c-2.2,0.1-4.4-0.2-6.5,0c-1.4,0.1-2.7,0.4-4,0.5c-2.2,0.2-4.4,0.2-6.7,0.1c-3.1,0.1-6.2-0.3-9.3-1.1 c0,0,0.2-3.4,0.2-3.7c0-1.6,0-1.7,1.6-1.8L398.6,503z"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M406.6,514.4c-5.2-0.2-10.4-0.2-15.6,0.2c-0.7,0.1-1.2,0.6-1.3,1.3l-0.5,4.1c-0.1,0.2,0,0.4,0.1,0.5 c0.1,0.1,0.2,0.1,0.4,0.1c2.2,0.1,4.4-0.2,6.5,0c1.4,0.1,2.7,0.4,4,0.5c2.2,0.2,4.4,0.2,6.7,0.1c3.1,0.1,6.2-0.3,9.3-1.1 c0,0-0.2-3.4-0.2-3.7c0-1.6,0.1-1.7-1.6-1.8L406.6,514.4z"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M341.9,507c0,0,14.7-0.8,17.4,0"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M359.2,499.1c0,0,6.4,6.4,6.4,7.9s-8.3,6.8-8.3,6.8"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M438.1,493.3c0,0,13.3-6.2,16.1-6.5"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M451.2,479.4c0,0,8.4,3.5,8.9,4.9s-5.1,9.4-5.1,9.4"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M437.9,509.3c0,0,13.5,5.8,15.6,7.6"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M457,509.7c0,0,3,8.6,2.3,9.9s-10.4,2.5-10.4,2.5"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M490.5,477.8c0.5,1.1,0.6,2.3,0.4,3.5c0,0.1,0,0.2-0.1,0.3c-0.1,0.1-0.3,0.2-0.4,0.1l-9.5,0.4 c0,0,0.5-2.8,0.6-3c0.3-1.1,1.2-0.8,2.2-0.9L490.5,477.8z"
  })), _polygon11 || (_polygon11 = /*#__PURE__*/React.createElement("polygon", {
    className: "st15",
    points: "310.9,564 314.2,560.9 311.2,560.8 309.7,563.2 "
  })), _polygon12 || (_polygon12 = /*#__PURE__*/React.createElement("polygon", {
    className: "st16",
    points: "286.7,585.9 290.3,581.4 291,580.5 302,569.1 305.7,565.2 307.4,565 309.9,562.6 311.4,563.8  308.9,566.7 309,568.2 305.2,572.3 294.5,583.9 293.8,584.7 289.5,588.6 "
  })), _polygon13 || (_polygon13 = /*#__PURE__*/React.createElement("polygon", {
    className: "st15",
    points: "291,580.5 302,569.1 305.2,572.3 294.5,583.9 "
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 2277.2546,
    y1: -14.4656,
    x2: 2277.2546,
    y2: 528.3815,
    gradientTransform: "matrix(1 0 0 -1 -2036.77 838.84)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#808080",
      stopOpacity: 0.25
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    style: {
      stopColor: "#808080",
      stopOpacity: 0.12
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#808080",
      stopOpacity: 0.1
    }
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    className: "st17",
    d: "M307.5,585c-3.2-2.9-5.9-6.3-8.2-10c-4.8-7.5-12.8-11.5-18.3-13.5V559l0.3-0.1l-0.1-2.3h0.1l-0.4-6v0l0,0 l-2-29.8c0,0-7-19.9,5.5-38.2s0.8-35.9-11-42.7c0,0-5.5-29-0.8-35.9c-6.4-3.7-12.9-7-19.7-10c-0.1-0.4-0.2-0.7-0.3-1.1 c-0.1-2.7-0.3-5.4-0.5-8.1c0.2-1.4,0.4-2.8,0.8-4.2c0.1-0.6,0.3-1.1,0.5-1.7c11.5-4.4,19.1-15.3,19.2-27.6c0-3.5-0.6-7-1.9-10.2 c0.6-1,1.1-2.2,1.4-3.3c0.8-3.1-0.1-6.4-1.9-9.5c-3.1-6.8-11-13.1-16.7-15.5c-8.1-3.3-20.4-2.5-28.9-1.5c-4.8,0.6-10.2,2.2-11.9,6.5 c-0.6,1.6-0.6,3.4-1.1,5c-1.8,6.7-9.5,9.8-14.2,14.9c-4.2,4.5-6,10.6-7.4,16.5c-3.9,17-4.8,34.5-2.8,51.9c0.5,4,1.1,8,1.8,11.9 c-2.9,4-5.4,11.1-4.3,23.4l-9.4,44.3l-3.9,25.9c0,0-2.4,10.7,7,19.8c6,5.8,13.2,15.7,17.7,22.1c-1.9,5.7-2.9,11.6-2.9,17.6 c0.1,2.7,0.2,5.3,0.4,7.8c0.4,5.3,1.4,10.6,3,15.6c1.1,10.7,3.3,24.3,7.5,33l1.6,46.5c0,0-2.4,42.7-7,51.1s10.2,79.4,10.2,79.4v9.9 l-2.5,7.3l-0.6-0.5c-11.7,14.5,0,19.8,0,19.8s3.2,0.2,8.3,0.3c-0.9,4.2,1.2,8.4,5,10.3c0,0,66.5,3,78.3,0s8.6-13.7,2.3-13 c-2.4,0.3-5.9-0.3-9.4-1.2c3.6-4.2,0.7-10-3.9-9.5c-6.3,0.8-20.4-4.8-20.4-4.8l-0.1,0.1c-0.4-0.2-0.9-0.3-1.4-0.4 c-5.2-1.2-10.4-2.6-15.5-4.3c-3-6.4-10-23.7-5-37.1c2.3-6.1,3-14.1,3-21.9c0.1-23.6,3.6-47,10.3-69.7l9.4-32 c0,0,13.3-38.9,14.1-49.6l-0.1-15.5c11,7,19.8,4.9,25.3,1.6c2.9-1.7,3.8-5.4,2.1-8.2C308.4,585.8,308,585.4,307.5,585z M203,503.9 c0.3-1.1,0.5-2.3,0.7-3.6c1.8,0,3.7,0,5.5-0.1c2.3,4.6,3.3,9.8,2.8,15C207.8,514,201.4,510.7,203,503.9L203,503.9z"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    className: "st18",
    d: "M210.5,810.8l-3,9l9.8,9.8l32.4,7.5l23.4-2.3l-1.5-8.3l0,0c-0.9-3.6-3.8-6.4-7.4-7.3 c-9.6-2.3-27.9-7.4-31.8-14.5L210.5,810.8z"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M210.5,810.8l-3,9l9.8,9.8l32.4,7.5l23.4-2.3l-1.5-8.3l0,0c-0.9-3.6-3.8-6.4-7.4-7.3 c-9.6-2.3-27.9-7.4-31.8-14.5L210.5,810.8z"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    className: "st19",
    d: "M265.5,832.6l-4.5-6l4.5-7c0,0,13.5,5.5,19.6,4.7s9,9.8-2.3,12.8s-75.3,0-75.3,0s-11.3-5.3,0-19.6l9.8,7.5 c0,0,16.6,9,24.9,7.5H265.5z"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    className: "st18",
    d: "M285.8,845.5l-23.4,2.3l-32.4-7.5l-9.8-9.8l0.8-2.4l1.1-3.4l1.1-3.3l21.8-6c1.1,1.8,2.6,3.3,4.4,4.4 c7.1,4.8,19.8,8.4,27.3,10.1c0.3,0.1,0.6,0.2,0.9,0.3c3.2,1.1,5.7,3.7,6.5,7L285.8,845.5z"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M285.8,845.5l-23.4,2.3l-32.4-7.5l-9.8-9.8l0.8-2.4l9,6.9c0,0,16.6,9,24.9,7.5h23.3l-4.5-6l4.1-6.3 c3.2,1.1,5.7,3.7,6.5,7L285.8,845.5z"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    className: "st19",
    d: "M278.2,843.2l-4.5-6l4.5-7c0,0,13.6,5.5,19.6,4.7s9,9.8-2.2,12.8s-75.3,0-75.3,0s-11.3-5.3,0-19.6l9.8,7.5 c0,0,16.6,9,24.9,7.5L278.2,843.2z"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    className: "st18",
    d: "M259.4,406.3c0,0-36.2,3.8-30.9-11.3c1.5-4.3,1.9-8.8,1.1-13.3c-0.9-5.5-3.1-10.8-6.4-15.3l33.9,5.3 c-2,3.4-3.6,7.1-4.6,10.9C248.5,398.5,259.4,406.3,259.4,406.3z"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    className: "st20",
    d: "M197.7,578.1c0,0,0.8,32.4,8.3,48.2l1.5,45.9c0,0-2.3,42.2-6.8,50.5s9.8,78.3,9.8,78.3v12c0,0,24.1,9,30.9-1.5 l-6.8-89.6l3-124.3L197.7,578.1z"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M197.7,578.1c0,0,0.8,32.4,8.3,48.2l1.5,45.9c0,0-2.3,42.2-6.8,50.5s9.8,78.3,9.8,78.3v12c0,0,24.1,9,30.9-1.5 l-6.8-89.6l3-124.3L197.7,578.1z"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M182.6,474.1l-4.5,12l-3.8,25.6c-1,7.2,1.5,14.5,6.8,19.6c9,9,21.1,27.9,21.1,27.9l14.3-42.9 c0,0-14.3-2.3-12-12.1c2.3-9.8,1.5-27.9,1.5-27.9L182.6,474.1z"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M249.6,819.8c-9.7,15.2-24.7,6.6-27.4,4.9l1.1-3.3l21.8-6C246.2,817.1,247.7,818.6,249.6,819.8z"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M279.8,607.4c-0.8,10.5-13.6,49-13.6,49l-9,31.6c-6.5,22.3-9.8,45.5-10,68.7c0,7.7-0.7,15.7-2.9,21.7 c-6,16.6,6,39.2,6,39.2c-10.5,18.8-28.6,6-28.6,6v-12c0,0-14.3-65.6-10.5-78.4c3.8-12.8,5.3-47.5,5.3-47.5v-62.5 c-12.1-12-19.4-28-20.7-45c-0.2-2.5-0.3-5.1-0.4-7.8c-0.6-17,11-36.9,15.5-44c1.1-1.7,1.8-2.7,1.8-2.7l66.5,26.4l0.1,0.1v2.6v5.7 L279.8,607.4z"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M257.2,371.7c-2,3.4-3.6,7.1-4.6,10.9c-7.4,2.8-15.7,2.5-22.9-0.8c-0.9-5.5-3.1-10.8-6.4-15.3L257.2,371.7z"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.1602 -0.9871 0.9871 0.1602 -145.696 535.9349)",
    className: "st18",
    cx: 242.1,
    cy: 353.6,
    rx: 29.4,
    ry: 29.4
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M279.8,558.5l-0.3,0.1c-31.6,6.5-71.2-26.4-71.2-26.4c1.1-1.8,2-3.7,2.7-5.6c1.1-1.7,1.8-2.7,1.8-2.7l66.5,26.4 l0.2,2.6L279.8,558.5z"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M271.5,405.6c0,0-42.2-25.6-55.7-15.1l-18.8,24.1c0,0-12.1,3.8-9.8,27.9l-9,43.7l27.1,6.8c0,0,15.8,15.1,3,36.9 c0,0,39.9,33.1,71.6,26.4l-2.3-35.4c0,0-6.8-19.6,5.3-37.7s0.8-35.4-10.5-42.2C272.2,441,267,412.3,271.5,405.6z"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    className: "st18",
    d: "M273.7,559.2c0,0,15.8,3,23.4,15.1c2.2,3.6,4.8,6.9,7.9,9.8c2.4,2.3,2.6,6,0.3,8.5c-0.4,0.4-0.8,0.8-1.3,1 c-6,3.6-15.7,5.8-28-4.3C254.9,572,273.7,559.2,273.7,559.2z"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M250.4,419.8c0,0-15.1-1.5-18.8,37.7s-9.8,48.2-9.8,48.2S218,526,227,538.1s26.4,37.8,26.4,37.8 s18.8,5.3,22.6-13.6l-23.4-43.7c0,0-3.8-15.1,5.3-25.6C267,482.5,273.7,412.3,250.4,419.8z"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M251.9,417.6c0,0-15.1-1.5-18.8,37.7s-9.8,48.2-9.8,48.2s-3.8,20.4,5.3,32.4s26.4,37.7,26.4,37.7 s18.8,5.3,22.6-13.5l-23.4-43.7c0,0-3.8-15.1,5.3-25.6C268.5,480.1,275.2,410.1,251.9,417.6z"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M264.3,445.8c0,0,1.5,23.4-5.3,36.2c-6.8,12.8-6.8,29.4,0,38.4"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M268.1,417.2c0,0-6-6-23.4-6.8s-24.9-6-24.9-6"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M226.2,315.6c-4.6,0.6-9.8,2.1-11.5,6.4c-0.6,1.6-0.6,3.3-1,5c-1.7,6.6-9.1,9.6-13.7,14.7 c-4,4.4-5.8,10.5-7.1,16.3c-3.8,16.8-4.7,34.1-2.7,51.1c1.5,12.5,4.5,24.8,5.3,37.3s-0.7,25.8-7.6,36.3c-3,4.5-6.8,8.5-8.9,13.5 c4.3,3.5,10.3,4,15.8,4.2c6.5,0.2,13,0.2,19.4,0c3.4-0.1,7-0.3,9.9-2.1c2.2-1.4,4-3.3,5.2-5.6c3.7-6.3,4.6-13.9,4.5-21.1 s-1.3-14.5-1.5-21.9c-0.1-4,0.2-8.2,2.5-11.5c1.6-2.4,4.2-3.9,6.3-5.8c8.1-7.1,10.8-18.6,11.1-29.4s-1.5-21.6-0.6-32.3 c0.4-4.2,1.9-9.2,6.1-10.1c1.3-0.3,2.7,0,3.9-0.5c3.3-1.3,3-6,3.9-9.4c1.1-3.9,4.4-6.8,5.3-10.7c2.2-9.1-9.4-20-17-23.2 C246.1,313.8,234.3,314.6,226.2,315.6z"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M225.4,314.1c-4.6,0.6-9.8,2.1-11.5,6.4c-0.4,1.6-0.8,3.3-1,5c-1.7,6.6-9.1,9.6-13.7,14.7 c-4,4.4-5.8,10.4-7.1,16.3c-3.7,16.8-4.6,34.1-2.6,51.2c1.5,12.5,4.5,24.8,5.3,37.3s-0.7,25.8-7.6,36.3c-3,4.5-6.8,8.5-8.9,13.5 c4.3,3.5,10.3,4,15.8,4.2c6.5,0.2,13,0.2,19.4,0c3.4-0.1,7-0.3,9.9-2.1c2.2-1.4,4-3.3,5.2-5.6c3.7-6.3,4.6-13.9,4.5-21.1 s-1.3-14.5-1.5-21.9c-0.1-4,0.2-8.2,2.5-11.5c1.7-2.4,4.2-3.9,6.3-5.8c8.1-7.1,10.8-18.6,11.1-29.4s-1.5-21.6-0.6-32.3 c0.4-4.2,1.9-9.2,6.1-10.1c1.3-0.3,2.7,0,3.9-0.5c3.3-1.3,3-5.9,3.9-9.4c1.1-3.9,4.3-6.8,5.3-10.7c2.2-9.1-9.4-20-17-23.2 C245.4,312.4,233.6,313.1,225.4,314.1z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgValue);
export default __webpack_public_path__ + "static/media/value.5d822b62b77551aba13f1fd159e71a8f.svg";
export { ForwardRef as ReactComponent };